import React, { useContext } from "react";
import { Column } from "react-table";
import { TableOptionsContext } from "config/tableOptionsProvider";
import { TABLE_IDS } from "constants/Interface";
import { Table } from "components";
import { AnimalFragment, AnimalWithTagFragment } from "generated/graphql";
import { animal } from "../api/fragments";
import { useApolloClient } from "@apollo/client";
import { removeNothings } from "helpers/general";
import { animalWithTag } from "tags/api/fragments";

type SourceTableId = typeof TABLE_IDS.ANIMAL_LIST_SERVER | typeof TABLE_IDS.ANIMAL_LIST_TAGS;

interface SelectedAnimalsTableProps {
  columns: Column<AnimalFragment | AnimalWithTagFragment>[];
  sourceTableId: SourceTableId;
}

export const SelectedAnimalsTable: React.FC<SelectedAnimalsTableProps> = ({ columns, sourceTableId }) => {
  const tableId = TABLE_IDS.ANIMAL_LIST_SERVER_SELECTED;

  const { getTableOptions } = useContext(TableOptionsContext);
  const client = useApolloClient();

  const sourceTableOptions = getTableOptions<AnimalFragment | AnimalWithTagFragment>(sourceTableId);
  const animalIds = React.useMemo(
    () => Array.from(sourceTableOptions?.selectedRowsIds ?? []),
    [sourceTableOptions?.selectedRowsIds],
  );
  const [data, setData] = React.useState<Array<AnimalFragment | AnimalWithTagFragment>>([]);

  React.useEffect(() => {
    const animals = animalIds.map((id) => {
      return client.readFragment<AnimalFragment | AnimalWithTagFragment>({
        id: `Animal:${id}`,
        fragment: sourceTableId === TABLE_IDS["ANIMAL_LIST_TAGS"] ? animalWithTag : animal,
      });
    });

    setData(removeNothings(animals));
  }, [animalIds, client, sourceTableId]);

  return (
    <Table<AnimalFragment | AnimalWithTagFragment>
      columns={columns}
      data={data}
      pagination
      initialPageSize={50}
      isAnimals
      tableId={tableId}
    />
  );
};
